export default "__VITE_ASSET__D0GAnVHS__"